import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { GameMutationKeys } from '../../../keys'
import {
	BatchUpdateGamePresetResponse,
	BatchUpdateGamePresetRequest,
} from '../../../type'
import { batchUpdateGamePreset } from '../../services'

export default function useMutationBatchUpdateGamePreset(
	props?: UseBaseMutationOptions<
		BatchUpdateGamePresetResponse,
		BatchUpdateGamePresetRequest
	>,
) {
	return useMutation({
		mutationKey: [GameMutationKeys.BatchUpdateGamePreset],
		mutationFn: (payload) => batchUpdateGamePreset(payload),
		...props,
	})
}
